export enum VariableType {
  STRING = 'STRING',
  ARRAY = 'ARRAY'
}
export enum VariableScope {
  BOT = 'BOT',
  WORKSHEET = 'WORKSHEET',
  USER = 'USER',
  LOCATION = 'LOCATION',
  SPACE = 'SPACE',
  CUSTOM = 'CUSTOM'
}
export interface VariableDefinitionInterface {
  id: string
  varName?: string // This is the name of the variable in the code. Not needed for custom made ones.
  name: string
  shortName?: string
  description?: string
  type?: VariableType
  hidden?: boolean
  scope?: VariableScope
}
const Def: VariableDefinitionInterface[] = []
